import { memo, ReactNode } from 'react';

import {
	TypographyComponent,
	TypographyVariant,
	TypographySize,
	TypographyWeight
} from '@vaa-component-lib/component.atom.typography';
import {
	IconNavigationChevronRightComponent,
	IconsProps,
	IconsSize
} from '@vaa-component-lib/component.atom.icons';
import {
	CriteriaButton,
	CriteriaErrorLabel,
	CriteriaInner,
	CriteriaLabels
} from './criteria-trigger.styles';
import React from 'react';

interface CriteriaTriggerComponentProps {
	label: string;
	value?: string;
	iconChild?: React.ReactElement<IconsProps>;
	onClick: () => void;
	aria: {
		controls: string;
		expanded: boolean;
	};
	hasError?: boolean;
	errorMessage?: string;
	disabled?: boolean;
}

const CriteriaTriggerComponent = ({
	label,
	value,
	iconChild,
	onClick,
	hasError = false,
	aria,
	errorMessage,
	disabled
}: CriteriaTriggerComponentProps) => {
	const hasValue = !!value;

	return (
		<CriteriaButton
			className={hasError && 'has-error'}
			data-cy="criteria-trigger-component"
			type="button"
			{...{ onClick, disabled }}
			aria-controls={aria.controls}>
			<CriteriaInner>
				{iconChild && React.cloneElement(iconChild, { size: IconsSize.Sml })}
				<CriteriaLabels>
					<TypographyComponent
						element="span"
						variant={TypographyVariant.Body}
						size={hasValue ? TypographySize.Xsm : TypographySize.Sml}
						weight={
							hasValue ? TypographyWeight.Medium : TypographyWeight.Regular
						}>
						{label}
					</TypographyComponent>
					{value && (
						<TypographyComponent
							element="span"
							variant={TypographyVariant.Body}
							size={TypographySize.Sml}
							weight={TypographyWeight.Regular}>
							{value}
						</TypographyComponent>
					)}

					{hasError && (
						<CriteriaErrorLabel data-cy="criteria-trigger-component-error">
							<TypographyComponent
								element="span"
								variant={TypographyVariant.Body}
								size={TypographySize.Xsm}
								weight={TypographyWeight.Regular}>
								{errorMessage}
							</TypographyComponent>
						</CriteriaErrorLabel>
					)}
				</CriteriaLabels>
			</CriteriaInner>
			<IconNavigationChevronRightComponent size={IconsSize.Sml} />
		</CriteriaButton>
	);
};

export default memo(CriteriaTriggerComponent);
